import { syncAction, syncSelector, syncReducer } from '../utils'
import { enGB } from '../../modules/Locales'

const { createClearAction, createSetAction } = syncAction
const name = 'userLocale'

export const set = (data) => (createSetAction(name, data))
export const clear = () => (createClearAction(name))

export const reducer = syncReducer(name, enGB)
export const selector = syncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/userLocale.js